import { RANGE_PRESETS } from "../../lib/fleetCalendar";

export function RangePresetSwitcher({ value, onChange }) {
  return (
    <div className="inline-flex items-center gap-1 p-1 rounded-lg bg-slate-100" data-testid="fc-range-switcher">
      {RANGE_PRESETS.map((p) => (
        <button
          key={p.id}
          type="button"
          data-testid={`fc-range-${p.id}`}
          onClick={() => onChange(p.id)}
          className={`px-3 py-1.5 rounded-md text-xs font-medium transition ${
            value === p.id ? "bg-white shadow-sm text-[#1B4332]" : "text-slate-600 hover:text-slate-900"
          }`}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
